/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Lightweight per-row ATS attribution for the jobs list.
 *
 * Present only when the job is linked to / imported from an external ATS;
 * null otherwise (which the UI renders as "No External ATS").
 */
export interface JobAtsLinkSummary {
  connector_id: string;
  connector_name: string;
  link_origin: string;
}
